/**
 * @class DropdownToggleButton
 *
 * Contains data for dropdown toggle button
 *
 * @property {string|React.ReactElement} label - label to be displayed in button
 * @property {string} className - specific classes to be applied to the button
 * @property {svg} svgBefore - svg to display before label
 * @property {svg} svgAfter - svg to display after label
 */
export default class DropdownToggleButton {
    /**
     *
     * @param {string|React.ReactElement} [label] - label to be displayed in the table cell
     * @param {string} [className] - specific classes to be applied to this table cell
     * @param {svg} svgBefore - svg to display before label
     * @param {svg} svgAfter - svg to display after label
     */
    constructor(label = "", className = "", svgBefore = undefined, svgAfter = undefined) {
        this._className = className;
        this._label = label;
        this._svgBefore = svgBefore;
        this._svgAfter = svgAfter;
    }

    /**
     * @returns {string}
     */
    get className() {
        return this._className;
    }

    /**
     * @returns {string | React.ReactElement}
     */
    get label() {
        return this._label;
    }

    /**
     * @returns {svg}
     */
    get svgBefore() {
        return this._svgBefore;
    }

    /**
     * @returns {svg}
     */
    get svgAfter() {
        return this._svgAfter;
    }
}
